import React from 'react';

export default function Root({ children, ...props }) {
  const componentDidMount = () => {
    document.title = props.title;
    const componentWillUnmount = () => { };
    return componentWillUnmount;
  }
  React.useEffect(componentDidMount, []);
  return (<>{children}</>);
}

Root.defaultProps = {
  title: "",
};
